import { render, staticRenderFns } from "./signUpApartmentSuccess.vue?vue&type=template&id=1dfbee9c&scoped=true"
import script from "./signUpApartmentSuccess.vue?vue&type=script&lang=js"
export * from "./signUpApartmentSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbee9c",
  null
  
)

export default component.exports